import CardHero from './card-hero';

export default CardHero;